import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { HeadingComponent } from '../heading';
import { IconV3Component } from '@gea/digital-ui-lib';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gea-hrt-info-box',
  standalone: true,
  template: `<div class="info-box">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <mat-card [class.with-border]="withBorder()">
          <ng-content>
            <div class="flex">
              <gea-hrt-heading>{{ boxTitle() | translate }}</gea-hrt-heading>
              <geaui-icon-v3
                pTooltip="{{ tooltip() | translate }}"
                [color]="'grey'"
                tooltipPosition="left"
                [file]="'c-info'"
                [fileSize]="16" />
            </div>
            <div><ng-content></ng-content></div>
          </ng-content>
        </mat-card>
      </div>
    </div>
  </div> `,
  styleUrls: ['./info-box.component.scss'],
  imports: [MatCard, HeadingComponent, IconV3Component, TooltipModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBoxComponent {
  readonly boxTitle = input('');
  readonly tooltipHeading = input('');
  readonly tooltip = input('');
  readonly withBorder = input<boolean | undefined>(false);
}
